import { FunctionComponent } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import authorizationService from 'common/services/security/authorizationService';
import SettingsPage from './SettingsPage';

const SettingsRouter: FunctionComponent = () => {
  const hasValidToken = authorizationService.hasValidToken();
  return (
    <>
      <Switch>
        <Route path="/projects/:projectId/settings">
          {hasValidToken ? <SettingsPage /> : <Redirect to="/" />}
        </Route>
      </Switch>
    </>
  );
};

export default SettingsRouter;
